import React from 'react';
import FeatureHeader from './FeatureHeader';
import styles from './FeatureIntro.module.css';

const FeatureIntro = () => {
    return (
        <div
            role="presentation"
            className={styles.featureIntro}
        >
            <div className={styles.absoluteOverlay}></div>
            <div className={styles.introGrid}>
                <div
                    role="presentation"
                    className={styles.introContent}
                >
                    <div className={styles.contentOverlay}></div>
                    <FeatureHeader />
                    <div className={styles.decorationIcon}>
                        <div className={styles.iconBackground}>
                            <img
                                src="https://c.animaapp.com/mhof1dcsmYxOSQ/assets/icon-11.svg"
                                alt="Icon"
                                className={styles.iconImage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeatureIntro;